import { motion } from "framer-motion";

/**
 * Wrap every route so page transitions feel cinematic.
 * Used inside AnimatePresence in App.js.
 */
export const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -16 }}
    transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);
